import {useContext} from "react";
import {FeatureTogglesContext} from "../featureToggles";

function useFeatureToggles() {
  return useContext(FeatureTogglesContext);
}

export default useFeatureToggles;
